// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"98":"f658e1fba29d83a4","390":"9ddf2b7da4ccd4f0","479":"bd1cd222bec357e9","564":"b0e9834f26ef7714","751":"2b0122d3679a830f"}[chunkId] + ".js";
};